import React, {forwardRef} from 'react'

import AzureDevOpsSVG from './AzureDevOpsSVG'
import GitHubSVG from './GitHubSVG'
import GitLabSVG from './GitLabSVG'
import JiraServerSVG from './JiraServerSVG'
import JiraSVG from './JiraSVG'
import MenuItem from './MenuItem'
import MenuItemAvatar from './MenuItemAvatar'
import MenuItemLabel from './MenuItemLabel'
import ParabolLogoSVG from './ParabolLogoSVG'
import TypeAheadLabel from './TypeAheadLabel'








export const integrationSvgLookup = {
  jiraServer: React.createElement(JiraServerSVG, null ),
  gitlab: React.createElement(GitLabSVG, null ),
  azureDevOps: React.createElement(AzureDevOpsSVG, null ),
  github: React.createElement(GitHubSVG, null ),
  jira: React.createElement(JiraSVG, null ),
  PARABOL: React.createElement(ParabolLogoSVG, null )
}

const TaskIntegrationMenuItem = forwardRef((props, ref) => {
  const {label, onClick, service, query} = props
  return (
    React.createElement(MenuItem, {
      ref: ref,
      label: 
        React.createElement(MenuItemLabel, null
          , React.createElement(MenuItemAvatar, null, integrationSvgLookup[service])
          , React.createElement(TypeAheadLabel, { query: query, label: label,} )
        )
      ,
      onClick: onClick,}
    )
  )
})

export default TaskIntegrationMenuItem
